module.exports = __webpack_public_path__ + "img/2.1de6e570.gif";